export const adminQuoteAttachmentUrlQueryKey = (attachmentId: string) =>
	["adminQuoteAttachments", attachmentId, true] as const;
